import React from "react";
export default ({
  className,
  style,
  onClick,
  disabled = false,
  color = null
}) => (
  <svg
    style={style}
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={
      className
        ? className + " " + (disabled && "disabled")
        : disabled && "disabled"
    }
    onClick={disabled ? null : onClick}
  >
    <path
      d="M14.3 6.5H11.7V11.7H6.5V14.3H11.7V19.5H14.3V14.3H19.5V11.7H14.3V6.5ZM13 0C5.8175 0 0 5.8175 0 13C0 20.1825 5.8175 26 13 26C20.1825 26 26 20.1825 26 13C26 5.8175 20.1825 0 13 0ZM13 23.4C7.267 23.4 2.6 18.733 2.6 13C2.6 7.267 7.267 2.6 13 2.6C18.733 2.6 23.4 7.267 23.4 13C23.4 18.733 18.733 23.4 13 23.4Z"
      fill={color ? color : disabled ? "#4D4D4D" : "#fff"}
    />
  </svg>
);
